import request from './request'
// 加入我们 岗位要求
export function recruit_page(data) {
  return request({
    url: '/web/recruit/v1/recruit_page',
    method: 'post',
    data
  })
}